var p = Object.defineProperty;
var r = (t, n, e) => n in t ? p(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var s = (t, n, e) => r(t, typeof n != "symbol" ? n + "" : n, e);
import { HttpClient as u, httpClient as o } from "../../httpClient.js";
class a extends u {
  constructor() {
    super(...arguments);
    s(this, "endpoint", "/course-plan");
  }
  async get() {
    return o.get(this.endpoint);
  }
  async getSuggestion(e) {
    return o.get(
      `${this.endpoint}/suggestion?degreeId=${encodeURIComponent(e)}`
    );
  }
  async save(e) {
    return o.post(this.endpoint, e);
  }
  async getOptions(e) {
    const i = e != null ? `?categoryId=${encodeURIComponent(e)}` : "";
    return o.get(`${this.endpoint}/options${i}`);
  }
}
const g = new a();
export {
  g as default
};
